var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFilialCardKb = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    rx: 8,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.313 16.25c0-.086-.13-.258-.215-.3l-9.97-3.782c-.042 0-.128-.043-.128-.043-.043 0-.129.043-.172.043l-9.969 3.781c-.086.043-.171.215-.171.301v.688c0 .214.128.343.343.343h1.031v.516c0 .3.215.515.516.515h16.844a.522.522 0 0 0 .515-.515v-.516h1.032a.339.339 0 0 0 .343-.343v-.688ZM31.28 29.313H12.72c-.602 0-1.031.472-1.031 1.03v.688c0 .215.128.344.343.344H31.97a.339.339 0 0 0 .343-.344v-.687c0-.559-.472-1.032-1.03-1.032ZM15.125 19v8.25h-1.547c-.3 0-.515.258-.515.516v.859h17.874v-.86c0-.257-.257-.515-.515-.515h-1.547V19h-2.75v8.25h-2.75V19h-2.75v8.25h-2.75V19h-2.75Z",
    fill: "#E25F6C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFilialCardKb);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/filial-card-kb.1fa1e49a8d50ac9960677f267d6442a2.svg";